import { render, staticRenderFns } from "./StudentListTable.vue?vue&type=template&id=6b5f1b10&scoped=true"
import script from "./StudentListTable.vue?vue&type=script&lang=js"
export * from "./StudentListTable.vue?vue&type=script&lang=js"
import style0 from "./StudentListTable.vue?vue&type=style&index=0&id=6b5f1b10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f1b10",
  null
  
)

export default component.exports